import React from 'react';
import './projects.scss';
import { useAuth } from  '../../contexts/auth'; 

import OffersTab from './offersTab.js';
import SupplierOrdersTab from './supplierOrdersTab.js';
import CustomerOrdersTab from './customerOrdersTab.js';
import CustomerInvoicesTab from './customerInvoicesTab.js';
import SupplierInvoicesTab from './supplierInvoicesTab.js';
import CostsTab from './costsTab.js';
import AccountingTab from './accountingTab.js';
import ProjectDocumentsTab from './documentsTab.js';
import CheckListTab from './checkListTab.js';
import CashFlow from './cashFlow.js';
import CashFlowTable from './cashFlowTable.js';

import CustomerDueTab from './customerDueTab.js';
import SupplierDueTab from './supplierDueTab.js';

import { TabPanel, Item } from 'devextreme-react/tab-panel';

import { useState, useEffect, useCallback } from "react";
import ScrollView from "devextreme-react/scroll-view";

import { Button } from 'devextreme-react/button';
import Toolbar from 'devextreme-react/toolbar';
import {Button as ToolbarButton} from 'devextreme-react/button';
import {IsRole_Admin,IsRole_OfficeManager,IsRole_ProjectManager,statoNotificaAttivitaOptions,tipoAttivitaOptions,SevenDaysFormatted, TodayFormatted} from '../../globals';

import {Popup as ToolbarPopup} from 'devextreme-react/popup';

import DataGrid, {
    Column,
    //Button,
    Editing,
    Selection,
    Lookup, 
    Form as GridForm
} from 'devextreme-react/data-grid';

import { createStore } from 'devextreme-aspnet-data';

import {
    Form,
    SimpleItem,
    //EmptyItem,
    GroupItem,
    CustomRule,
    RequiredRule
} from 'devextreme-react/form';

export default function ProjectDetail(props) {

    const { user } = useAuth(); 
    //const [detail, setDetail] = useState({});
    const isAdmin =IsRole_Admin();
    const isOfficeManager =IsRole_OfficeManager();
    const isProjectManager =IsRole_ProjectManager();

    const [collaboratori, setCollaboratori] = useState({});

    var attivitaDataGridRef = React.createRef();

    function renderOffersTab() {
        return <OffersTab projectId = {props.data.key}  />;
    }
  
    function renderSupplierOrdersTab() {
        return <SupplierOrdersTab projectId = {props.data.key} />;
    }

    function renderCustomerOrdersTab() {
        return <CustomerOrdersTab projectId = {props.data.key} />;
    }

    function renderCustomerInvoicesTab() {
        return <CustomerInvoicesTab projectId = {props.data.key} />;
    }

    function renderSupplierInvoicesTab() {
        return <SupplierInvoicesTab projectId = {props.data.key} />;
    }

    function renderCostsTab() {
        return <CostsTab projectId = {props.data.key} />;
    }

    function renderAccountingTab() {
        return <AccountingTab projectId = {props.data.key} />;
    }

    function renderDocumentsTab() {
        return <ProjectDocumentsTab projectId = {props.data.key} nome = {props.data.data.codice} />;
    }

    function renderCheckListTab() {
        return <CheckListTab projectId = {props.data.key} />;
    }

    function renderCustomerDueTab() {
        return <CustomerDueTab projectId = {props.data.key} />;
    }

    function renderSupplierDueTab() {
        return <SupplierDueTab projectId = {props.data.key} />;
    }

    const onTabSelectionChanged = useCallback((e) => {
        //notify("The button was clicked");
        ;
    }, []);

    const onTabSelectionChanged2 = useCallback((e) => {
        //notify("The button was clicked");
        ;
    }, []);

    const renderForecastCFTab = () => {
        return (
            <div className={'mystats-container'}> 
               
                <div className={'mystats-title'}>
                    Cash Flow Forecast
                </div>
                <div className={'mystats-data'}>
                    <CashFlowTable projectId = {props.data.key}  type = "Forecast"/>
                </div>

                <div className={'mystats-graph-data'}>
                    <CashFlow projectId = {props.data.key} type = "Forecast"/>
                </div>

                 
            </div>
        )
    };

    const renderOriginalCFTab = () => {
        return (
            <div className={'mystats-container'}> 
               
                <div className={'mystats-title'}>
                    Cash Flow Original
                </div>
                <div className={'mystats-data'}>
                    <CashFlowTable projectId = {props.data.key} type = "Original" />
                </div>

                <div className={'mystats-graph-data'}>
                    <CashFlow projectId = {props.data.key} type = "Original"/>
                </div>

                 
            </div>
        )
    };

     const renderActualCFTab = () => {
        return (
            <div className={'mystats-container'}> 
               
                <div className={'mystats-title'}>
                    Cash Flow Actual
                </div>
                <div className={'mystats-data'}>
                    <CashFlowTable projectId = {props.data.key} type = "Actual" />
                </div>

                <div className={'mystats-graph-data'}>
                    <CashFlow projectId = {props.data.key} type = "Actual"/>
                </div>

                 
            </div>
        )
    };



    const [projectValue, setProjectValue] = useState({});
    const [realValue, setRealValue] = useState({});
    const [transactions, setTransactions] = useState({});
    const [activities, setActivities] = useState({});

    const numberFormatter = new Intl.NumberFormat('it-IT', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });

    const [isPopupVisible3, setPopupVisibility3] = useState(false);
    const togglePopup3 = () => {
        setPopupVisibility3(!isPopupVisible3);
    };

    const serviceUrl3 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/CommessaAttivita'
    const remoteDataSource3 = createStore({
        
        key: 'id',
        loadUrl: serviceUrl3 + '/FindByCommessa/' + props.data.key,
        onBeforeSend: (method, ajaxOptions) => {
            ajaxOptions.headers = { Authorization: `Bearer ${user.token}`};   
        },  
        insertUrl: serviceUrl3 + '/InsertAction',
        updateUrl:serviceUrl3 + '/UpdateAction',
        deleteUrl: serviceUrl3 + '/DeleteAction'
        
    });

    useEffect(() => {

        const fetchData = async () => {
    
        const requestOptions = {
            headers: {
                Authorization: `Bearer ${user.token}`
            }
        };

        const prjId = props.data.key;

        const newServiceUrl1 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Commessa';
        var newUrl1 =  newServiceUrl1 + "/GetProjectValues/" + prjId;

        const newServiceUrl2 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Commessa';
        var newUrl2 =  newServiceUrl2 + "/GetRealValues/" + prjId;

        const newServiceUrl3 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Commessa';
        var newUrl3 =  newServiceUrl3 + "/GetTransactions/" + prjId;

        const newServiceUrl4 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Commessa';
        var newUrl4 =  newServiceUrl4 + "/GetPercActivities/" + prjId;

          const newServiceUrl5 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Collaboratore';
          var newUrl5 =  newServiceUrl5 + "/GetCollaboratori";
    
          try {
    
            const response1 = await fetch(newUrl1,requestOptions);
            const json1 = await response1.json();
            console.log(json1);
            setProjectValue(json1);

            const response2 = await fetch(newUrl2,requestOptions);
            const json2 = await response2.json();
            console.log(json2);
            setRealValue(json2);

            const response3 = await fetch(newUrl3,requestOptions);
            const json3 = await response3.json();
            console.log(json3);
            setTransactions(json3);

            const response4 = await fetch(newUrl4,requestOptions);
            const json4 = await response4.json();
            console.log(json4);
            setActivities(json4);

            const response5 = await fetch(newUrl5,requestOptions);
            const json5 = await response5.json();
            console.log(json5);
            setCollaboratori(json5);
    
          } catch (error) {
            console.log("error", error);
          }
        };
    
        fetchData();
      }, []);
    

    function GetMargine() {

        //var costiEffettivi = "";
        //var ricaviEffettivi = "";
        var fatturato = 0;
        var fatturatoFormat = "";
        var margine = 0;
        var margineFormat = "";
        var delta = 0;
        var deltaFormat = "";
        var ricaviEffettivi = 0;
        var deltaFatturato = 0;
        var deltaFatturatoFormat = "";

        if (realValue[0] !== undefined){
            ricaviEffettivi = realValue[0].totaleRicavi;
            margine = realValue[0].totaleRicavi - realValue[0].totaleCosti
            margineFormat = numberFormatter.format(margine);
            fatturato = realValue[0].totaleFatturato;
            fatturatoFormat = realValue[0].totaleFatturatoFormat;

            if (realValue[0].totaleCosti > 0) {
                
                delta = (((100 * realValue[0].totaleRicavi) / realValue[0].totaleCosti) -100).toFixed(0);
                if (delta >= 0)
                    deltaFormat = "(+" + delta + "%)"
                else
                    deltaFormat = "(" + delta + "%)"
            }
            if (ricaviEffettivi > 0) {
                deltaFatturato = (((100 * fatturato) / ricaviEffettivi)).toFixed(0);
                if (deltaFatturato >= 0)
                    deltaFatturatoFormat = "(" + deltaFatturato + "%)"
                else
                    deltaFatturatoFormat = "(" + deltaFatturato + "%)"
            }
        }
        if (margine >= 0)
            return  (
                <div>
                    <div className={'mystats-container-small'}>                
                        <div className={'mystats-data-small'}>Margine:&nbsp;<b> {margineFormat}</b> &nbsp;&nbsp;&nbsp;<b>{deltaFormat}</b></div>  
                        <div className={'mystats-data-small'}>Importo Fatturato:&nbsp;<b> {fatturatoFormat} </b>&nbsp;&nbsp;&nbsp;<b>{deltaFatturatoFormat}</b></div>
                    </div>
                </div>
            )
        else
            return  (
                <div>
                    <div className={'mystats-container-small'}>                
                        <div className={'mystats-data-small-red'}>Margine:&nbsp;<b> {margineFormat} </b>&nbsp;&nbsp;&nbsp;<b>{deltaFormat}</b></div>  
                        <div className={'mystats-data-small'}>Importo Fatturato:&nbsp;<b> {fatturatoFormat} </b>&nbsp;&nbsp;&nbsp;<b>{deltaFatturatoFormat}</b></div>
                    </div>
                </div>
            )
    };

    function GetCosti() {

        var costiPrevisti = "";
        var costiEffettivi = "";
        var delta = 0;
        var deltaFormat = "";
        if (projectValue[0] !== undefined && realValue[0] !== undefined){
            costiPrevisti = projectValue[0].totaleCostiFormat;
            costiEffettivi = realValue[0].totaleCostiFormat;
            if (projectValue[0].totaleCosti > 0) {
                delta = (((100 * realValue[0].totaleCosti) / projectValue[0].totaleCosti) -100).toFixed(0);
                if (delta >= 0)
                    deltaFormat = "(+" + delta + "%)"
                else
                    deltaFormat = "(" + delta + "%)"
            }
        }
        
        return  (
            <div>
                <div className={'mystats-container-small'}>
                    <div className={'mystats-data-small'}>Costi Previsti:&nbsp;<b> {costiPrevisti} </b></div>
                    <div className={'mystats-data-small'}>Costi Effettivi:&nbsp;<b>{costiEffettivi}</b>&nbsp;&nbsp;&nbsp;<b>{deltaFormat}</b></div>
                </div>
            </div>
        )
    };

    function GetRicavi() {

        var ricaviPrevisti = "";
        var ricaviEffettivi = "";
        var delta = 0;
        var deltaFormat = "";
        if (projectValue[0] !== undefined && realValue[0] !== undefined){
            ricaviPrevisti = projectValue[0].totaleRicaviFormat;
            ricaviEffettivi = realValue[0].totaleRicaviFormat;
            if (projectValue[0].totaleRicavi > 0) {
                delta = (((100 * realValue[0].totaleRicavi) / projectValue[0].totaleRicavi) -100).toFixed(0);
                if (delta >= 0)
                    deltaFormat = "(+" + delta + "%)"
                else
                    deltaFormat = "(" + delta + "%)"
            }
        }
        
        return  (
            <div>
                <div className={'mystats-container-small'}>
                    <div div className={'mystats-data-small'}>Ricavi Previsti:&nbsp;<b> {ricaviPrevisti} </b></div>
                    <div div className={'mystats-data-small'}>Ricavi Effettivi:&nbsp;<b>{ricaviEffettivi}</b>&nbsp;&nbsp;&nbsp;<b>{deltaFormat}</b></div>
                </div>
            </div>
        )
    };
    
    function GetTransazioni() {
        var daPagareFormat = "";
        var pagatoFormat = "";
        var daPagare = 0;
        var pagato = 0;
        var daIncassareFormat = "";
        var incassatoFormat = "";
        var daIncassare = 0;
        var incassato = 0;

        var deltaPagato = 0;
        var deltaPagatoFormat = "";
        var deltaIncassato = 0;
        var deltaIncassatoFormat = "";

        var totalePagamenti = 0;
        var totaleIncassi = 0;
        if (transactions[0] !== undefined){
            daPagare = transactions[0].daPagare;
            pagato = transactions[0].pagato;
            daPagareFormat = transactions[0].daPagareFormat;
            pagatoFormat = transactions[0].pagatoFormat;
            daIncassare = transactions[0].daIncassare;
            incassato = transactions[0].incassato;
            daIncassareFormat = transactions[0].daIncassareFormat;
            incassatoFormat = transactions[0].incassatoFormat;
            totalePagamenti = transactions[0].daPagare + transactions[0].pagato;
            totaleIncassi = transactions[0].daIncassare + transactions[0].incassato;
            if (totalePagamenti > 0) {
                deltaPagato = (((100 * pagato) / totalePagamenti) ).toFixed(0);
                if (deltaPagato >= 0)
                    deltaPagatoFormat = "(" + deltaPagato + "%)"
                else
                    deltaPagatoFormat = "(" + deltaPagato + "%)"
            }
            if (totaleIncassi > 0) {
                deltaIncassato = (((100 * incassato) / totaleIncassi)).toFixed(0);
                if (deltaIncassato >= 0)
                    deltaIncassatoFormat = "(" + deltaIncassato + "%)"
                else
                    deltaIncassatoFormat = "(" + deltaIncassato + "%)"
            }
            
        }
        
        return  (
            <div>
                <div className={'mystats-container-small'}>
                    <div div className={'mystats-data-small'}>Importo pagamenti:&nbsp;<b>{pagatoFormat}</b>&nbsp;&nbsp;&nbsp;<b>{deltaPagatoFormat}</b></div>
                    <div div className={'mystats-data-small'}>Saldo pagamenti:&nbsp;<b> {daPagareFormat} </b></div>        
                </div>
                <div className={'mystats-container-small'}>
                    <div div className={'mystats-data-small'}>Importo incassi:&nbsp;<b>{incassatoFormat}</b>&nbsp;&nbsp;&nbsp;<b>{deltaIncassatoFormat}</b></div>
                    <div div className={'mystats-data-small'}>Saldo incassi:&nbsp;<b> {daIncassareFormat} </b></div>  
                </div>
            </div>
        )
    };

    function GetActivities() {

        var durata = 0;
        var durataFormat = "";
        var completato = 0;
        var completatoFormat = "";
        var completatoPerc = 0;
        var completatoPercFormat = "";

        if (activities[0] !== undefined){
            durata = activities[0].durata;
            durataFormat = numberFormatter.format(durata);
            completato = activities[0].completato;
            completatoFormat = numberFormatter.format(completato);
            completatoPerc = activities[0].percCompletato;
            completatoPercFormat = "(" + completatoPerc.toFixed(0) + "%)"
        }
        return  (
            <div>
                <div className={'mystats-container-small'}>
                <div div className={'mystats-data-small'}>Attività (gg):&nbsp;<b> {durataFormat} </b></div>
                <div div className={'mystats-data-small'}>Completate:&nbsp;<b>{completatoFormat}</b>&nbsp;&nbsp;&nbsp;<b>{completatoPercFormat}</b></div>
                </div>
            </div>
        )
    };

    const infoHint= "Creata da " + props.data.data.createBy + " il " + props.data.data.strCreateDate + "\n" + "Modificata da " + props.data.data.updateBy + " il " + props.data.data.strUpdateDate ;
    
     const validateCompletata = (e) => {

        var isCompletata = e.value;
        console.log("isCompletata:" + isCompletata);
        var scadenza = e.data.dataScadenza;
        if(scadenza === undefined )
            return true;
        console.log("scadenza:" + scadenza);
        if (scadenza !== null && isCompletata === false) 
          return false;
        else
          return true;
    };

    const onCellPreparedGrid = (e) => {
    
        if (e.rowType === "data") {
            if (e.column.dataField === "dataAttivita") { 
                var isCompletata = e.data.completata;
                var dataAttivita = e.data.dataAttivita;

                if (isCompletata)
                {
                    e.cellElement.style.cssText = "color: lightgreen;font-weight: bold";
                }
                else if (dataAttivita < TodayFormatted())
                {
                    e.cellElement.style.cssText = "color: red; font-weight: bold";
                }
                else if ((dataAttivita < SevenDaysFormatted()) &&  (dataAttivita >= TodayFormatted()) )
                {
                    e.cellElement.style.cssText = "color: orange; font-weight: bold";
                }
            
            }
        }

    }

    const showEditButton = useCallback((e) => {
        if (isProjectManager || isAdmin)
            return true
        else
        {
            return e.row.data.completata === false;
        }
    }, []);

    const renderContent3 = () =>  {

        const onEditorPreparing = (e) => { 
        if (e.parentType === 'dataRow' && e.dataField === 'descrizione') {  
            e.editorOptions.maxLength = 400;  
        }  
    } 

    const getDefaultData = async () => {
        const serviceUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/CommessaAttivita';
        var url = serviceUrl + "/GetDefaultValues/" + props.data.key + "/" + user.userId;
        const requestOptions = {
            headers: {
                Authorization: `Bearer ${user.token}`
            }
        };
    
        try {
            //console.log("Fetching data from:", url);
            const response = await fetch(url, requestOptions);
    
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
    
            const data = await response.json();
            console.log("Fetched data:", data);
            return data;
        } catch (error) {
            console.error("Error fetching default data:", error);
            return null;
        }
    };

    const handleInitNewRow = (e) => {
        e.data.dataAttivita = new Date();
        e.data.completata = false;
        e.data.createBy = user.name;
    
        e.promise = getDefaultData().then((defaultData) => {
    
            if (defaultData && typeof defaultData === "object") {
                e.data.collaboratoreId = defaultData.collaboratoreId || null;
                e.data.riferimentoCliente = defaultData.riferimentoCliente || null;
            } else {
                console.warn("Warning: Default data is null or undefined");
            }
        }).catch((error) => {
            console.error("Errore durante l'inizializzazione della riga:", error);
        });
    };

    function onRowInserting(e) {
        e.data.commessaId = props.data.key;
    };


    return (
        <ScrollView height="100%">
        <div style={{ padding: "10px" }}>
            <div>
                <div className="offer-title-small" align="left" > 
                    <h3>Commessa n° {props.data.data.codice} del {props.data.data.strDataInizio} - {props.data.data.cliente}</h3>
                </div>
                <DataGrid id="grid-subcontainer"
                    dataSource={remoteDataSource3}
                    onRowInserting={onRowInserting}
                    onInitNewRow={handleInitNewRow}
                    showBorders={true}
                    onCellPrepared={onCellPreparedGrid}
                    dateSerializationFormat= {'yyyy-MM-dd'}
                    ref={ref => attivitaDataGridRef = ref}
                    onEditorPreparing={onEditorPreparing}
                >
                    <Selection mode="single" />
                    <Toolbar>
                        <Item name="addRowButton"  />
                    </Toolbar>
                    <Editing
                        mode="form"
                        allowUpdating={true}
                        allowAdding={true}
                        allowDeleting={true}
                        useIcons={true}
                    >
                        <GridForm>
                            <SimpleItem dataField="dataAttivita" />
                            <SimpleItem dataField="collaboratoreId" />
                            <SimpleItem dataField="tipoAttivitaId" />
                            <SimpleItem dataField="riferimentoCliente" />
                            <SimpleItem dataField="descrizione" colSpan={2} />
                            <SimpleItem dataField="dataScadenza" />
                            <SimpleItem dataField="completata" editorType='dxCheckBox'></SimpleItem>
                            <SimpleItem dataField="statoNotificaId" />
                            <SimpleItem dataField="statoNotifica2Id" />
                        </GridForm>

                    </Editing>
                    <Column dataField="id" visible={false}/>
                    <Column dataField="dataAttivita" dataType="date" format= {'dd/MM/yyyy'} caption="Data attività" width={120} >
                        <RequiredRule/>
                    </Column>
                    <Column dataField="collaboratoreId" caption="Assegnatata a" width={140} >
                        <Lookup dataSource={collaboratori} valueExpr="id" displayExpr="cognome" />
                        <RequiredRule/>
                    </Column>
                    <Column dataField="tipoAttivitaId" caption="Tipo Attività" visible={false}>
                        <Lookup dataSource={tipoAttivitaOptions} displayExpr="desc" valueExpr="id" />
                        <RequiredRule/>
                    </Column>
                    <Column dataField="descrizione" caption = "Attività">
                        <RequiredRule/>
                    </Column>
                    <Column dataField="riferimentoCliente" caption = "Rif. Cliente" width={120} visible={false}/>
                    <Column dataField="dataScadenza" dataType="date" format= {'dd/MM/yyyy'} caption="Follow up" width={120}/>
                    <Column dataField="completata" width={80} caption="Compl.">
                        <CustomRule type="custom" message={"L'attività deve essere completata se è previsto un Follow-up"} validationCallback={validateCompletata} />
                    </Column>
                    <Column dataField="statoNotificaId" caption="Notifica al DC" visible={false} >
                        <Lookup dataSource={statoNotificaAttivitaOptions} displayExpr="desc" valueExpr="id" />
                    </Column>
                        <Column dataField="statoNotifica2Id" caption="Notifica all'assegnatario" visible={false} >
                        <Lookup dataSource={statoNotificaAttivitaOptions} displayExpr="desc" valueExpr="id" />
                    </Column>
                    <Column dataField="createBy" visible={false}/>
                    <Column type="buttons">
                        <Button name="edit" visible={showEditButton} />
                        <Button name="delete" visible={showEditButton}/>
                    </Column>
                </DataGrid>
            </div>   
        </div>
    </ScrollView> 
    )}


    return (
    
    
        <div>
            <div className="project-title" align="left"> 
               <h2>Commessa {props.data.data.codice} del {props.data.data.strDataInizio} -  {props.data.data.cliente}</h2>  
            </div>
            
            <div className="project-button-refresh" align="right">     
                <Toolbar>
                     <Item location="after">
                        <ToolbarButton className="offer-toolbar"
                        icon='clock'
                        hint='Attività'
                        onClick={togglePopup3}
                    />
                    </Item>
                    <Item location="after">
                       <Button className="offer-toolbar"
                       icon='refresh'
                       hint='Aggiorna'
                       //onClick={showMessage} 
                    />
                    </Item>
                    <Item location="after">
                       <Button className="project-toolbar"
                       icon='info'
                       hint= {infoHint}
                    />
                    </Item>              
                </Toolbar>
            </div>

             <div>
                <TabPanel    
                    showNavButtons={true}
                    adaptivityEnabled={true}
                    onSelectionChanged={onTabSelectionChanged2}
                >
                    <Item title="Forecast" render={renderForecastCFTab} />
                    <Item title="Original" render={renderOriginalCFTab} />
                    <Item title="Actual" render={renderActualCFTab} />
                </TabPanel>  
            </div>
           
             <div className={'mystats-data'}>
              
            </div>

            <div>
                <TabPanel    
                    showNavButtons={true}
                    adaptivityEnabled={true}
                    onSelectionChanged={onTabSelectionChanged}
                >
                    <Item title="Documenti" render={renderDocumentsTab} />
                    <Item title="CheckList" render={renderCheckListTab} />
                    <Item title="Offerte" render={renderOffersTab} />
                    <Item title="Ordini Fornitori" render={renderSupplierOrdersTab} />
                    <Item title="Ordini Clienti" render={renderCustomerOrdersTab} />
                     {(isAdmin || isOfficeManager)  && (
                    <>
                        <Item title="Fatture Fornitori" render={renderSupplierInvoicesTab} />
                        <Item title="Fatture Clienti" render={renderCustomerInvoicesTab} />
                        <Item title="Spese" render={renderCostsTab} />
                        <Item title="Pagamenti" render={renderSupplierDueTab} />
                        <Item title="Incassi" render={renderCustomerDueTab} />
                        <Item title="Contabilità Analitica" render={renderAccountingTab} />
                    </>
                    )}   
                </TabPanel>
                    
            </div>  

            <div>
                <ToolbarPopup
                    width={1080}
                    height={640} 
                    showTitle={true}
                    title="Attività"
                    visible={isPopupVisible3}
                    hideOnOutsideClick={true}
                    onHiding={togglePopup3}
                    contentRender={renderContent3}
                > 
                </ToolbarPopup> 
            </div>
        </div> 
)};